module.exports = require('./helpers/bundle-url').getBundleURL('01RMl') + "qr-github.093ecf25.png";